import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  Button,
  ConfirmationModal,
  IconCart,
  IconRefresh,
} from "@touchtech/web-baselayer-ui";

import { TranslationContext } from "@is/constants";

import css from "./RestartSearchModal.module.css";

type Props = {
  onRestart: () => void;
  onClose: () => void;
};

const RestartSearchModal = ({ onRestart, onClose }: Props) => {
  const { t } = useTranslation(TranslationContext.ProductListing);

  return (
    <ConfirmationModal isOpen onClose={onClose}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {t("Are you sure to restart?")}
        </h1>
        <span className={classcat(["text-label-xl", css.text])}>
          {t("You will erase all of your search history.")}
        </span>

        <Button
          className={classcat([css.modalButton, css.restartButton])}
          width="full"
          sizing="lg"
          onClick={onRestart}
        >
          <IconRefresh />
          {t("Yes, restart")}
        </Button>
        <Button
          variant="tertiary"
          className={css.modalButton}
          width="full"
          sizing="lg"
          onClick={onClose}
        >
          <IconCart />
          {t("No, continue shopping")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default RestartSearchModal;
